// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-newsie-dashboard {
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 5px;
  flex:1 1;
  height: 100%;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/ManagePublicationNewsies.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,QAAM;EACN,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".manage-newsie-dashboard {\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  gap: 5px;\n  flex:1;\n  height: 100%;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
